"use client";
import React, { useEffect, useRef, useState } from "react";
import Image, { StaticImageData } from "next/image";
import Slider from "react-slick";

import user_jenny_dean from "@/assets/img/testimonial/jenny-dean.jpeg";
import user_jeff_rohwer from "@/assets/img/testimonial/jeff-rohwer.jpeg";
import user_sharon_feder from "@/assets/img/testimonial/sharon-feder.jpeg";
import user_rochelle_miller from "@/assets/img/testimonial/rochelle-miller.jpg"
import user_louis_meletiou from "@/assets/img/testimonial/louis-meletiou.jpg"
import user_tim_spector from "@/assets/img/testimonial/tim-spector.jpg"
import user_luzanne_janse_van_rensburg from "@/assets/img/testimonial/Luzaan-Janse-van-Rensburg.jpg"

import StarIcon from "@/svg/icons/StarIcon.svg";
import QuoteIcon from "@/svg/icons/quote.svg";
import { gsap } from "gsap";
import { Icon } from "@/svg/Icon";
import { Style } from "util";

interface DataType {
  subtitle: string;
  title: string;
  info: string;
  testimonial_slider_data: {
    id: number;
    rating_text?: string;
    description: string;
    img: StaticImageData;
    name: string;
    designation: string;
    company?: string;
    designation2?: string;
    company2?: string;
  }[];
}

const testimonial_content: DataType = {
  subtitle: "Testimonials",
  title: "What clients say",
  info: "",
  testimonial_slider_data: [
    {
      id: 3,
      rating_text: "5.0 Rating",
      description: `“As a first time author, I wrote a book focused on creating modern customer experiences for life sciences companies. Marie helped to ensure it made sense strategically and operationally. She has a truly unique mix of talent, focus and discipline to make sure content creators are creating content that is valuable for a community and the author. I would highly recommend her for any creative endeavor.“`,
      img: user_jeff_rohwer,
      name: "Jeff Rohwer",
      designation: "Chief Transformation Officer",
      company: "Real Chemistry",
    },
    {
      id: 1,
      rating_text: "",
      description: `“Marie helped me translate the science of healthy eating in an accessible way for my book. Working with her improved the clarity and structure immensely.”`,
      img: user_tim_spector,
      name: "Tim Spector, MD FRCP FRSB",
      designation: "Professor",
      company: "King’s College London",
      designation2: "Scientific co-founder",
      company2: "ZOE"
    },
    {
      id: 2,
      rating_text: "5.0 Rating",
      description: `“Marie’s sharp eye, fine ear and clear thinking mean that, when she takes a brief, you can trust that she’ll own it and deliver to the highest standard. She is wonderfully collaborative and committed, and a joy to work with. I hope I have many more chances to work with her again in the future.“`,
      img: user_jenny_dean,
      name: "Jenny Dean",
      designation: "Deputy Publishing Director",
      company: "Penguin Random House",
    },
    {
      id: 4,
      rating_text: "5.0 Rating",
      description: `“It’s rare to find talent like Marie. In addition to being a passionate and empathetic leader, Marie is a skilled writer and editor with a strong track record of balancing complex and often scientific topics with an accessible approach. She is the first person I call when I have a new project. I can’t recommend her highly enough.“`,
      img: user_sharon_feder,
      name: "Sharon Feder",
      designation: "VP Brand Marketing",
      company: "ZOE",
    },
    {
      id: 5,
      description: `“Marie is a true professional: responsive, communicative, and reliable throughout. Thanks to her guidance, my manuscript became significantly stronger, and I feel more confident in moving forward with publication. If you're looking for a smart, perceptive, and collaborative editor, I wholeheartedly recommend Marie.“`,
      img: user_rochelle_miller,
      name: "Rochelle Miller, PhD",
      designation: "Media Archives PM",
      company: "AAPB"
    },
    {
      id: 6,
      description: `“Identifying complicated issues and opportunities as she went, Marie transformed our content production process from top to bottom in a ridiculously short period of time. Content production touches all aspects of our business and Marie played a huge part in laying the foundations for our success.“`,
      img: user_louis_meletiou,
      name: "Louis Meletiou",
      designation: "Head of Digital",
      company: "Medico Digital"
    },
    {
      id: 7,
      description: `“Marie took a hopeful writer and has helped turn me into an aspiring author. She has helped shape my journey in every aspect; she’s a true inspiration and mentor and is extremely knowledgeable in her field.“`,
      img: user_luzanne_janse_van_rensburg,
      name: "Luzaan Janse van Rensburg",
      designation: "Book Coaching Client",
      designation2: "Founder & Director",
      company2: "ELM Studios",
    }
  ],
};

const PrevArrowButton = (props: {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`tp-testimonial-arrow tp-testimonial-arrow-prev ${className}`}
      onClick={onClick}
      style={{ ...style, display: "block" }}
    >
      <Icon name="HomeTwoPortfolioLeftArrow" />
    </div>
  );
};

const NextArrowButton = (props: {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`tp-testimonial-arrow tp-testimonial-arrow-next ${className}`}
      onClick={onClick}
      style={{ ...style, display: "block" }}
    >
      <Icon name="HomeTwoPortfolioRightArrow" />
    </div>
  );
};

const { subtitle, title, info, testimonial_slider_data } = testimonial_content;

// slider a
const slider_a = {
  dots: false,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  focusOnSelect: true,
  nextArrow: <NextArrowButton />,
  prevArrow: <PrevArrowButton />,
};
// slider b
const slider_b = {
  dots: false,
  arrows: false,
  centerPadding: "0px",
  slidesToShow: 7,
  slidesToScroll: 1,
  focusOnSelect: true,
  centerMode: true,
  // responsive: [
  //   {
  //     breakpoint: 992,
  //     settings: {
  //       slidesToShow: 2,
  //     },
  //   },
  //   {
  //     breakpoint: 576,
  //     settings: {
  //       slidesToShow: 1,
  //     },
  //   },
  // ],
};

const MuseTestimonialArea = () => {
  const bg_img = "";

  useEffect(() => {
    let testi_Line_1 = document.querySelectorAll(".tp-testimonial-nav-border");

    testi_Line_1.forEach((line, index) => {
      gsap.set(line, {
        width: 0,
      });
      gsap.to(line, {
        scrollTrigger: {
          trigger: ".tp-testimonial-nav-border",
          start: "top 90%",
          end: "bottom 80%",
          markers: false,
        },
        width: "100%",
      });
    });
  });

  useEffect(() => {
    let testi_Line_1 = document.querySelectorAll(".tp-testimonial-user-border");

    testi_Line_1.forEach((line, index) => {
      gsap.set(line, {
        width: 0,
      });
      gsap.to(line, {
        scrollTrigger: {
          trigger: ".tp-testimonial-user-border",
          start: "top 90%",
          end: "bottom 80%",
          markers: false,
        },
        width: "100%",
      });
    });
  });

  const [slider1, setSlider1] = useState<Slider | null>(null);
  const [slider2, setSlider2] = useState<Slider | null>(null);
  const sliderRef = useRef<Slider | null>(null);

  return (
    <section
      id={"testimonials"}
      //style={{ backgroundImage: `url(/assets/img/bg/distort-bg.png)` }}
      className={`tp-testimonial-area theme-bg tp-bg-light pb-40 pt-25`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="tp-testimonial-section-title">
              <div className="tp-section-title-wrapper tp_text_anim mb-50 text-center">
                <div className="tp-section-title-inner tp_title_anim p-relative">
                  <span className="tp-section-subtitle">{subtitle}</span>
                  <h3 className="tp-section-title">{title}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="tp-testimonial-slider ml-70 mr-70">
              <Slider
                {...slider_a}
                asNavFor={slider2 as Slider}
                ref={(slider) => {
                  setSlider1(slider);
                  sliderRef.current = slider;
                }}
                className="tp-testimonial-slider-active swiper-container theme-bg-2"
              >
                {testimonial_slider_data.map((item, i) => (
                  <div key={i} className="swiper-slide">
                    <div className="tp-testimonial-item theme-bg-2">
                      {/* <div className="tp-testimonial-quote">
                        <QuoteIcon />
                      </div> */}
                      <div className="tp-testimonial-content">
                        <p>{item.description}</p>
                      </div>
                      <div className="tp-testimonial-user-item d-flex">
                        <span className="tp-testimonial-user-border"></span>
                        <div className="tp-testimonial-user-thumb">
                          <Image src={item.img} alt="image-here" />
                        </div>
                        <div className="tp-testimonial-user-content">
                          <h3 className="tp-testimonial-user-title">
                            {item.name}
                          </h3>
                          <div>
                          <span className="tp-testimonial-user-designation">
                            {item.designation}
                            {item.company && " at "}
                          </span>
                          {item.company && <span className="tp-testimonial-user-company">
                            {item.company}
                          </span>}
                          </div>
                          {item.designation2 && (
                              <div>
                              <span className="tp-testimonial-user-designation">
                                {item.designation2}
                                {item.company2 && " at "}
                              </span>
                              {item.company2 && <span className="tp-testimonial-user-company">
                                {item.company2}
                              </span>}
                              </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>

              <div className="tp-testimonial-thumb-slider">
                <Slider
                  {...slider_b}
                  asNavFor={slider1 as Slider}
                  ref={slider => {
                    setSlider2(slider);
                  }}
                  className="tp-testimonial-nav swiper-container"
                >
                  {testimonial_slider_data.map((item, index) => (
                    <div key={index} className="swiper-slide">
                      <div className="tp-testimonial-nav-item d-flex justify-content-center align-items-center">
                        <span className="tp-testimonial-nav-border"></span>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MuseTestimonialArea;
